<template>
    <a-modal
            :width="'50%'"
            v-model="updateCustom"
            :title="$t('org.customInfo')"
            :maskClosable="maskClosable"
            @ok="handleOk"
            :confirmLoading="okLoading">
        <div style="padding:20px;">
            <a-card>
                <a-form :form="customerForm">
                    <a-form-item :label="$t('org.entityTemplate')" v-bind="formItemLayout" v-if="level >= 3 && (isSuperAdmin || isIntegrator)">
                        <a-input size="small" v-model="org.entityTemplateName" disabled></a-input>
                    </a-form-item>

                    <!-- <a-form-item label='系统名称' v-bind="formItemLayout">
                        <a-input size="small" v-model="org.systemName" v-decorator="['systemName',{ rules: [{ required: true, message: '请输入系统名称!' },{ validator: hasSpecialChar}, {max: 15, message: '系统名称长度应在15字以内'}] }]"></a-input>
                    </a-form-item> -->

                    <a-form-item :label="$t('org.systemName')" v-bind="formItemLayout">
                        <a-input size="small" v-model="org.systemName"></a-input>
                    </a-form-item>

                    <a-form-item :label="$t('org.systemLogo')" v-bind="formItemLayout">
                        <a-avatar shape="square" size="large" v-if="imageUrl" :src= "imageUrl"/>
                        <span v-else>{{$t('global.none')}}</span>
                        <a-upload
                                :action="imageUploadUrl + '?type=system'"
                                :format="['png']"
                                :beforeUpload="beforeUpload"
                                :showUploadList="false"
                                @change="handleChange"
                                :headers="token">
                            <a-button size="small" type="primary" style="margin-left:15px">
                                <a-icon type="upload" style="padding-right:4px"/>
                                {{$t('global.upload')}}
                            </a-button>
                        </a-upload>

                        <a-button size="small" style="margin-left:15px" @click="deleteLogo" v-if="imageUrl">
                            <a-icon type="delete" style="padding-right:4px"/>
                            {{$t('global.delete')}}
                        </a-button>
                    </a-form-item>

                    <a-alert style="left:12%;width:80%" :message="$t('global.tips')" type="info" showIcon>
                        <p slot="description">
                            1：{{$t('global.imgPngTip')}}
                            <br/>
                            2：{{$t('global.imgSizeTip')}}
                        </p>
                    </a-alert>

                </a-form>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import {hasSpecialChar} from '../../utils/formFunctions'
    import {mapGetters, mapActions} from 'vuex'
    export default {
        name: 'ZUpdateOrgCustomer',
        computed: {
            ...mapGetters([
                'isSuperAdmin','isIntegrator'
            ])
        },
        data() {
            return {
              okLoading: false,
                maskClosable:false,
                updateCustom: false,
                customerForm: null,
                imageUploadUrl: config.api.file_upload_url,
                org: {},
                level: null,
                imageUrl: '',
                formItemLayout: {
                    labelCol: {
                        xs: { span: 18 },
                        sm: { span: 5 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 },
                    }
                }
            }
        },
        methods: {
          ...mapActions(['setOrg']),
            deleteLogo(){
                this.imageUrl = ''
            },
            hasSpecialChar,
            handleOk(){
                this.customerForm.validateFieldsAndScroll((err, values) => {
                    if (!err) {
                        this.okLoading = true
                        let org = {}
                        org.id = this.org.id
                        org.logo = this.imageUrl
                        org.systemName = this.org.systemName
                        this.$http.put(config.api.org_custom_url,org).then((response) => {
                            // console.log(response)
                            let {result} = response
                            if(response.code == 0){
                                this.updateCustom = false
                                let orgPayload = {
                                  level: result.level,
                                  orgName: result.name,
                                  systemImage: result.logo,
                                  systemName: result.systemName,
                                }
                                this.setOrg(orgPayload)
                                // this.$message.success('修改成功')
                                this.$notification.success({
                                  message: this.$t('global.commitSuccess')
                                })
                                this.$emit("updateSuccess",this.org.id)
                            } else {
                                this.$message.error(response.desc)
                            }
                            this.okLoading = false
                        })
                    }
                })
            },
            beforeUpload (file) {
                // console.log(file)
                const isPic = (file) => {
                    if (file.type.includes('image/png') || file.type.includes('image/jpeg')) {
                        return true
                    } else {
                        return false
                    }
                }
                // console.log(isPic(file))
                if(!isPic(file)){
                // if(file.type.indexOf('image/png') == -1 || file.type.indexOf('image/jpeg') == -1){
                    this.$notification["warning"]({
                      message: this.$t('global.tips'),
                      description: this.$t('global.imgPngTip'),
                    })
                    return false
                }
                // let fileSize = file.size
                if(file.size >= 1048576){
                    this.$notification["warning"]({
                      message: this.$t('global.tips'),
                      description: this.$t('global.imgSizeTip'),
                    })
                    return false
                }
                return true
            },
            handleChange(info) {
                if (info.file.status === 'done' && info.file.response.code == 0) {
                    this.imageUrl = info.file.response.result.imageUrl
                }
            },
            showModel(org){
              // console.log(org)
                this.org = org
                this.level = org.link.split(',').length - 1
                this.imageUrl = org.logo == null ? '' : org.logo
                this.customerForm = this.$form.createForm(this)
                this.updateCustom = true
                let _this = this
                setTimeout(() => {
                    _this.customerForm.setFieldsValue({
                        systemName: org.systemName
                    });
                },200);

            }
        },
        created () {
            this.token = {Authorization:'Bearer ' + this.$store.getters.token}
        }
    }
</script>